var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreyBigPencilIcon = function SvgGreyBigPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#grey-big-pencil-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8999AF",
    d: "M19.044.957a3.022 3.022 0 0 0-4.27 0L1.221 14.51A4.14 4.14 0 0 0 0 17.456v1.71A.833.833 0 0 0 .833 20h1.711a4.14 4.14 0 0 0 2.946-1.22L19.044 5.226a3.022 3.022 0 0 0 0-4.27ZM4.312 17.602c-.47.466-1.105.73-1.768.731h-.877v-.877a2.483 2.483 0 0 1 .732-1.768L12.685 5.402l1.917 1.917-10.29 10.283ZM17.865 4.047l-2.088 2.09-1.917-1.913 2.09-2.089a1.353 1.353 0 1 1 1.912 1.917l.003-.005Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grey-big-pencil-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgGreyBigPencilIcon;